import { Box, Grid, LinearProgress, Stack } from "@mui/material";
import { useTripTagsByCategory } from "../orders/useTripTagsByCategory";
import { filterPackages } from "./filterPackages";
import PackageCard from "./PackageCard";
import "./PublicPackagesList.scss";
import PublicPackagesSearch from "./PublicPackagesSearch";
import { usePublicPackages } from "./usePublicPackages";
import { usePublicPackagesSearch } from "./usePublicPackagesSearch";

const PublicPackagesPage = () => {
  const { searchCriteria, setSearchCriteria } = usePublicPackagesSearch();
  const { packages, isLoading: arePackagesLoading } = usePublicPackages();
  const { tripTagsByCategory, isLoading: areTagsLoading } = useTripTagsByCategory();
  const isLoading = arePackagesLoading || areTagsLoading;
  const packagesToShow = filterPackages(packages, searchCriteria.tags);
  return (
    <Stack
      spacing={1}
      sx={{
        marginTop: 1,
      }}
    >
      {isLoading && <LinearProgress />}
      <Box
        sx={{
          flexGrow: 1,
          overflow: "auto",
        }}
      >
        <Grid container>
          <Grid size={{ xs: 3, xl: 2 }}>
            <PublicPackagesSearch
              value={searchCriteria}
              tagsByCategory={tripTagsByCategory}
              onChange={setSearchCriteria}
            />
          </Grid>
          <Grid size={{ xs: 9, xl: 8 }} className="public-packages-list">
            {packagesToShow.map((p) => (
              <PackageCard key={p.id.id} value={p} />
            ))}
          </Grid>
          <Grid size={{ xs: 0, xl: 2 }} />
        </Grid>
      </Box>
    </Stack>
  );
};

export default PublicPackagesPage;
